import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';

import { env } from '@/config/env';
import en from '@/locales/en.json';
import es from '@/locales/es.json';
import pt from '@/locales/pt.json';

export const SUPPORTED_LANGUAGES = [
  { value: 'en', label: 'English', flag: '🇺🇸' },
  { value: 'pt', label: 'Português', flag: '🇧🇷' },
  { value: 'es', label: 'Español', flag: '🇪🇸' },
] as const;

export type Language = (typeof SUPPORTED_LANGUAGES)[number]['value'];

const fallbackLng: Language = 'en';
const supportedLngs: Language[] = SUPPORTED_LANGUAGES.map((l) => l.value);

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng,
    supportedLngs,
    debug: env.DEV,
    interpolation: {
      escapeValue: false,
    },
    resources: {
      en: { translation: en },
      pt: { translation: pt },
      es: { translation: es },
    },
  });

export default i18n;
